export default __webpack_public_path__ + "static/media/Nosotros-1.39000ec3.webp";